<!-- 表1填写 -->

<template>
  <div class="tabCage ssTab2E">
    <div class="tabTtl">
      <span>出版单位基本信息</span>
    </div>
    <div class="tips">
      注：本表中所指“连续型电子出版物出版单位”，是指依照《电子出版物出版管理规定》经批准办理审批和履行登记手续的出版单位，法人单位出版连续型电子出版物且不再设立法人出版单位的，其设立的连续型电子出版物编辑部视为连续型电子出版物出版单位。
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">单位名称：</td>
            <td class="edInp">
              <el-form-item prop="publishName" :inline-message="true">
                <el-input style="width: 600px" v-model="params.publishName" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物品种：</td>
            <td class="edInp">
              <el-input-number
                type="input"
                controls-position="right"
                :min="0"
                :precision="0"
                v-model="pzs"
                disabled
                size="small"></el-input-number>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-form-item prop="publishAddr" :inline-message="true">
                <el-input style="width: 600px" v-model="params.publishAddr" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-form-item prop="publishPostalcode" :inline-message="true">
                <el-input v-model="params.publishPostalcode" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-form-item prop="publishLinkman" :inline-message="true">
                <el-input v-model="params.publishLinkman" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-form-item prop="publishTel" :inline-message="true">
                <el-input v-model="params.publishTel" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">主办单位：</td>
            <td class="edInp">
              <el-form-item prop="hostName" :inline-message="true">
                <el-input style="width: 600px" v-model="params.hostName" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">主管单位：</td>
            <td class="edInp">
              <el-form-item prop="chargeName" :inline-message="true">
                <el-input style="width: 600px" v-model="params.chargeName" disabled size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物出版单位职工总数：</td>
            <td class="edInp">
              <el-form-item prop="workers" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.workers"
                  disabled
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物业务人员数：</td>
            <td class="edInp">
              <el-form-item prop="businessWorkers" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.businessWorkers"
                  disabled
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">其中取得中级以上资格证书人员数：</td>
            <td class="edInp">
              <el-form-item prop="otherWorkers" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.otherWorkers"
                  disabled
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td class="edName">法人身份：</td>
            <td class="edInp">
              <el-form-item prop="unitType" :inline-message="true">
                <el-select v-model="params.unitType" size="small" disabled placeholder="请选择">
                  <el-option v-for="item in dicDats['C016']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td class="edName">演变情况：</td>
            <td class="edInp">
              <el-form-item prop="evolution" :inline-message="true">
                <el-input type="textarea" :rows="3" disabled v-model="params.evolution" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>

          <!-- 新增 start -->
          <tr>
            <td class="edName">2023年出版单位年销售收入（万元）：</td>
            <td class="edInp">
              <el-form-item prop="firstTotalSales" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.firstTotalSales"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">2024年出版单位年销售收入（万元）：</td>
            <td class="edInp">
              <el-form-item prop="secondTotalSales" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.secondTotalSales"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">2023出版单位年度利润（税后）总额（万元）：</td>
            <td class="edInp">
              <el-form-item prop="firstTotalProfit" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :precision="2"
                  v-model="params.firstTotalProfit"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">2024出版单位年度利润（税后）总额（万元）：</td>
            <td class="edInp">
              <el-form-item prop="secondTotalProfit" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :precision="2"
                  v-model="params.secondTotalProfit"
                  :controls="false"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物<br />出版单位（主办单位）<br />具有的出版资质：</td>
            <td class="edInp">
              <!-- <el-checkbox-group v-model="cbzzArray" style="line-height:22px;"> -->
              <el-checkbox
                disabled
                v-model="params.qualificationTs"
                true-label="1"
                false-label="0"
                label="图书"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationQk"
                true-label="1"
                false-label="0"
                label="期刊"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationYx"
                true-label="1"
                false-label="0"
                label="音像"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationDz"
                true-label="1"
                false-label="0"
                label="电子"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationWl"
                true-label="1"
                false-label="0"
                label="网络"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationBz"
                true-label="1"
                false-label="0"
                label="报纸"></el-checkbox>
              <!-- </el-checkbox-group> -->
            </td>
          </tr>

          <tr>
            <td class="edName">营收高于出版业务<br />的其他主营业务：</td>
            <td class="edInp">
              <!-- placeholder="请输入所在出版单位主营出版业务(营收高于音像电子业务的出版业务）" -->
              <el-form-item prop="otherbusiness" :inline-message="true">
                <el-input
                  disabled
                  type="textarea"
                  :rows="3"
                  v-model="params.otherbusiness"
                  placeholder="请输入"
                  size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">除传统光盘载体出版外<br />在哪些方面有所拓展：</td>
            <td class="edInp">
              <!-- <el-checkbox-group v-model="extendyw" style="line-height:22px;"> -->
              <el-checkbox
                disabled
                v-model="params.expandBusinessMedium"
                true-label="1"
                false-label="0"
                label="新媒体"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessWeb"
                true-label="1"
                false-label="0"
                label="直接通过网络传播的出版物"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessBook"
                true-label="1"
                false-label="0"
                label="图书出版物(此项由盘配书试点单位选填)"></el-checkbox
              ><br />
              <el-checkbox v-model="params.expandBusinessOther" disabled true-label="1" false-label="0" label="其他">
              </el-checkbox>
              <el-input
                disabled
                v-if="params.expandBusinessOther == '1'"
                v-model="params.expandBusinessOtherFill"
                true-label="1"
                false-label="0"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请输入其他"></el-input>
              <br />
              <el-checkbox
                v-model="params.expandBusinessEmpty"
                disabled
                true-label="1"
                false-label="0"
                label="无"></el-checkbox
              ><br />
              <!-- </el-checkbox-group> -->
            </td>
          </tr>
          <!-- 新增 end -->

          <tr>
            <td class="edName">备注：</td>
            <td class="edInp">
              <el-form-item prop="remark" :inline-message="true">
                <el-input type="textarea" :rows="3" disabled v-model="params.remark" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
        <div class="headBar">
          <span>申报人信息</span>
        </div>
        <div class="editArea">
          <table>
            <tr>
              <td class="edName">申报人：</td>
              <td class="edInp">
                <el-input disabled v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">联系方式：</td>
              <td class="edInp">
                <el-input disabled v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">申报时间：</td>
              <td class="edInp">
                <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsSEt2";
import { ssSave2, ssRead2 } from "@/api/pressRole/pressSuccessive";
export default {
  data() {
    return {
      pzs: 0,
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 1,
      imgId: "",

      declare: {
        personnel: "",
        contact: "",
      },
    };
  },
  watch: {
    "params.areaDate": function (dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    },
  },
  methods: {
    editSave: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;
          ssSave2({
            plxdzBasic: this.params,
          })
            .then((response) => {
              this.submiting = false;
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              // for(let key in this.params){
              // 	 this.params[key] = '';
              // };
              this.goBack();
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    dictInit: function () {
      let nameArr = ["C016"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      newPromise.then((result) => {
        this.dicDats = result;
      });
    },

    tabReEdit: function () {
      ssRead2({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        this.params = response.plxdzBasic;
        this.pzs = response.pzs;

        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },

    layChange: function () {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function () {
      this.$router.go(-1);
      // this.$router.push({
      // 	 path:'successive_skim',
      // 	 query:{
      // 	 	 mtId:this.$route.query.mtId,
      // 	 	 pressId:this.$route.query.pressId,
      // 	 	 listId:this.$route.query.listId,
      // 	 	 bookName:this.$route.query.bookName
      // 	 }
      // });
    },
  },
  created: function () {
    this.dictInit();
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.ssTab2E {
  margin-top: 0px;

  .edName {
    width: 300px !important;
  }

  .edInp .el-input-number {
    width: 300px;
  }

  .el-textarea {
    width: 450px;
  }

  .tips {
    padding: 12px 20px;
    color: #999999;
  }
}

.el-date-editor {
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// ssTab2.vue?32a72ca4